module.exports = __webpack_public_path__ + "static/media/gear.2bac8582.svg";